import React from "react";
import Alert from "./Alert";
const getKind = (props) => {
    const { success, error } = props;
    if (error) {
        return "error";
    }
    if (success) {
        return "success";
    }
    return "none";
};
const getChildren = (props) => {
    const { success, error } = props;
    if (error) {
        return error;
    }
    if (success) {
        return success;
    }
    return "";
};
const AlertSwitch = ({ success, error, className }) => {
    return (React.createElement(Alert, { kind: getKind({ success, error }), className: className }, getChildren({ success, error })));
};
export default AlertSwitch;
